export function Logo({ compact = false }: { compact?: boolean }) {
  return <div className="logo">
    <span className="logo-mark"><img src="/brand/tikgo-dog-line.png" alt="" /></span>
    {!compact && <span>tikgo</span>}
  </div>;
}
